export default "__VITE_ASSET__IyWc_aes__"